import c from '@/styles/ArticleDate';
import { ClassNameProp, Component, ComponentProps } from '@/types/component';
import { cn } from 'lib/utils/cn';
import { getPropStylesFactory } from 'lib/utils/getPropStylesFactory';

export interface ArticleDateUpdatedProps extends ComponentProps<'span'> {
  colors?: ClassNameProp<'default'>;
  size?: ClassNameProp<'default'>;
  variant?: ClassNameProp<'default'>;
}

export const ArticleDateUpdatedComponent: Component<ArticleDateUpdatedProps> = ({
  children,
  className,
  colors,
  size,
  variant,
  ...props
}) => {
  const getPropStyles = getPropStylesFactory(c);

  const colorsClassName = getPropStyles('updated_colors', colors, 'default');
  const sizeClassName = getPropStyles('updated_size', size, 'default');
  const variantClassName = getPropStyles('updated_variant', variant, 'default');
  const componentClassName = cn(colorsClassName, sizeClassName, variantClassName, className);

  return (
    <span className={componentClassName} {...props}>
      {children}
    </span>
  );
};
